import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
import { GameState, GameStatus, COLORS, BUBBLE_RADIUS, ROW_HEIGHT, GRID_COLS, GRID_ROWS, SHOTS_BEFORE_NEW_ROW } from '@utils/game/bubbleShooter/constants.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import audioManager from '@utils/game/bubbleShooter/audioManager.js';
import CanvasLoop from '@utils/game/bubbleShooter/canvasLoop.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
export default {
  name: 'bubbleShooter',
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", "setting"])
  },
  data() {
    return {
      gameState: {
        ...GameState
      },
      revives: 10,
      maxRevives: 10,
      lastScore: 0,
      timeVal: null,
      stimeVal: null,
      leftTime: 0,
      prizePool: 0,
      timePeriod: "",
      userReward: null,
      popUserRewardShow: false,
      popGameRankShow: false,
      popStartShow: false,
      popLostShow: false,
      popOpenMobileShow: false,
      angleRef: Math.PI / 2,
      currentBubble: null,
      nextBubbleColor: COLORS[Math.floor(Math.random() * COLORS.length)],
      canvasLoop: null
    };
  },
  watch: {
    "gameState.status": {
      handler(newStatus, oldStatus) {
        if (newStatus === GameStatus.MENU) {
          this.popStartShow = true;
          this.popLostShow = false;
        }
        if (newStatus === GameStatus.GAMEOVER) {
          this.popLostShow = true;
          this.popStartShow = false;
        }
        if (newStatus === GameStatus.PLAYING) {
          this.popStartShow = false;
          this.popLostShow = false;
          const canvas = this.$refs.canvasRef;
          this.canvasLoop = new CanvasLoop(canvas, {
            update: this.update,
            draw: this.draw,
            BUBBLE_RADIUS,
            GRID_COLS,
            ROW_HEIGHT,
            GRID_ROWS
          });
          this.canvasLoop.start();
        }
      }
    },
    'gameState.score': {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          this.end();
        }, 500);
      },
      deep: true,
      immediate: true
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.stimeVal);
      clearTimeout(this.timeVal);
      this.end();
    } catch (error) {}
    if (this.canvasLoop) {
      this.canvasLoop.stop();
    }
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    initGrid() {
      const newGrid = [];
      for (let r = 0; r < GRID_ROWS; r++) {
        newGrid[r] = [];
        for (let c = 0; c < GRID_COLS; c++) {
          if (r < 4) {
            newGrid[r][c] = COLORS[Math.floor(Math.random() * COLORS.length)];
          } else {
            newGrid[r][c] = null;
          }
        }
      }
      this.gameState.grid = newGrid;
      this.gameState.shotsFired = 0;
      this.gameState.topRowOffset = 0;
      this.gameState.shotsCount = 0;
    },
    addNewRow() {
      // Shift all rows down
      const newGrid = [...this.gameState.grid];

      // Check if bottom row has bubbles - Game Over
      const lastRow = newGrid[GRID_ROWS - 1];
      if (lastRow.some(b => b !== null)) {
        this.gameState.status = GameStatus.GAMEOVER;
        audioManager.play('fail');
        return;
      }

      // Move everything down
      for (let r = GRID_ROWS - 1; r > 0; r--) {
        newGrid[r] = [...newGrid[r - 1]];
      }

      // Add new random row at top
      newGrid[0] = [];
      for (let c = 0; c < GRID_COLS; c++) {
        newGrid[0][c] = COLORS[Math.floor(Math.random() * COLORS.length)];
      }
      this.gameState.grid = newGrid;
      this.gameState.topRowOffset = 1 - this.gameState.topRowOffset;
    },
    getBubbleCoords(row, col) {
      const isOdd = (row + this.gameState.topRowOffset) % 2 === 1;
      const x = col * BUBBLE_RADIUS * 2 + (isOdd ? BUBBLE_RADIUS : 0) + BUBBLE_RADIUS;
      const y = row * ROW_HEIGHT + BUBBLE_RADIUS;
      return {
        x,
        y
      };
    },
    getGridPos(x, y) {
      const row = Math.round((y - BUBBLE_RADIUS) / ROW_HEIGHT);
      const isOdd = (row + this.gameState.topRowOffset) % 2 === 1;
      const col = Math.round((x - (isOdd ? BUBBLE_RADIUS : 0) - BUBBLE_RADIUS) / (BUBBLE_RADIUS * 2));
      return {
        row,
        col
      };
    },
    spawnBubble() {
      const canvas = this.$refs.canvasRef;
      if (!canvas) return;
      const dpr = window.devicePixelRatio || 1;
      const logicalWidth = canvas.width / dpr;
      const logicalHeight = canvas.height / dpr;
      this.currentBubble = {
        x: logicalWidth / 2,
        y: logicalHeight - 40,
        color: this.nextBubbleColor,
        vx: 0,
        vy: 0,
        active: false
      };
      this.nextBubbleColor = COLORS[Math.floor(Math.random() * COLORS.length)];
    },
    startGame() {
      this.initGrid();
      this.currentBubble = null;
      this.gameState.score = 0;
      this.revives = this.maxRevives;
      this.gameState.status = GameStatus.PLAYING;
      setTimeout(() => {
        this.spawnBubble();
      }, 200);
    },
    shoot(e) {
      if (!this.currentBubble || this.currentBubble.active || this.gameState.status !== GameStatus.PLAYING) return;
      // Prevent default to avoid scrolling on touch
      if ('touches' in e) {
        // For touch, we update angle one last time before shooting
        const touch = e.touches[0];
        this.updateAngle(touch.clientX, touch.clientY);
      }
      const speed = 20;
      this.currentBubble.vx = Math.cos(this.angleRef) * speed;
      this.currentBubble.vy = -Math.sin(this.angleRef) * speed;
      this.currentBubble.active = true;
      this.gameState.shotsFired++;
      this.gameState.shotsCount = this.gameState.shotsFired % SHOTS_BEFORE_NEW_ROW;
      audioManager.play('shoot');
    },
    updateAngle(clientX, clientY) {
      const canvas = this.$refs.canvasRef;
      if (!canvas) return;
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      const logicalWidth = canvas.width / dpr;
      const logicalHeight = canvas.height / dpr;
      const centerX = logicalWidth / 2;
      const centerY = logicalHeight - 40;
      const dx = clientX - rect.left - centerX;
      const dy = clientY - rect.top - centerY;
      this.angleRef = Math.atan2(-dy, dx);
      if (this.angleRef < 0.1) this.angleRef = 0.1;
      if (this.angleRef > Math.PI - 0.1) this.angleRef = Math.PI - 0.1;
    },
    findNeighbors(row, col) {
      const neighbors = [];
      const isOdd = (row + this.gameState.topRowOffset) % 2 === 1;
      const offsets = !isOdd ? [[-1, -1], [-1, 0], [0, -1], [0, 1], [1, -1], [1, 0]] : [[-1, 0], [-1, 1], [0, -1], [0, 1], [1, 0], [1, 1]];
      for (const [dr, dc] of offsets) {
        const nr = row + dr;
        const nc = col + dc;
        if (nr >= 0 && nr < GRID_ROWS && nc >= 0 && nc < GRID_COLS) {
          neighbors.push({
            row: nr,
            col: nc
          });
        }
      }
      return neighbors;
    },
    popBubbles(row, col, color) {
      const matches = [{
        row,
        col
      }];
      const queue = [{
        row,
        col
      }];
      const visited = new Set();
      visited.add(`${row},${col}`);
      while (queue.length > 0) {
        const curr = queue.shift();
        const neighbors = this.findNeighbors(curr.row, curr.col);
        for (const neighbor of neighbors) {
          const key = `${neighbor.row},${neighbor.col}`;
          if (!visited.has(key) && this.gameState.grid[neighbor.row][neighbor.col] === color) {
            visited.add(key);
            matches.push(neighbor);
            queue.push(neighbor);
          }
        }
      }
      if (matches.length >= 3) {
        matches.forEach(m => {
          this.gameState.grid[m.row][m.col] = null;
        });
        this.gameState.score += matches.length * 10;
        this.dropFloatingBubbles();
        audioManager.play('pop');
        return true;
      }
      return false;
    },
    dropFloatingBubbles() {
      const connected = new Set();
      const queue = [];
      for (let c = 0; c < GRID_COLS; c++) {
        if (this.gameState.grid[0][c]) {
          connected.add(`0,${c}`);
          queue.push({
            row: 0,
            col: c
          });
        }
      }
      while (queue.length > 0) {
        const curr = queue.shift();
        const neighbors = this.findNeighbors(curr.row, curr.col);
        for (const neighbor of neighbors) {
          const key = `${neighbor.row},${neighbor.col}`;
          if (!connected.has(key) && this.gameState.grid[neighbor.row][neighbor.col]) {
            connected.add(key);
            queue.push(neighbor);
          }
        }
      }
      for (let r = 0; r < GRID_ROWS; r++) {
        for (let c = 0; c < GRID_COLS; c++) {
          if (this.gameState.grid[r][c] && !connected.has(`${r},${c}`)) {
            this.gameState.grid[r][c] = null;
            this.gameState.score += 15;
          }
        }
      }
    },
    update(dt) {
      if (this.gameState.status !== GameStatus.PLAYING) return;
      const canvas = this.$refs.canvasRef;
      if (!canvas) return;
      // Update Shot Bubble with sub-stepping to prevent tunneling
      if (this.currentBubble && this.currentBubble.active) {
        const b = this.currentBubble;
        const dpr = window.devicePixelRatio || 1;
        const logicalWidth = canvas.width / dpr;
        const logicalHeight = canvas.height / dpr;
        const steps = 3; // Split movement into 3 steps
        const stepVx = b.vx / steps;
        const stepVy = b.vy / steps;
        for (let s = 0; s < steps; s++) {
          b.x += stepVx;
          b.y += stepVy;

          // Wall Bounce
          if (b.x - BUBBLE_RADIUS < 0 || b.x + BUBBLE_RADIUS > logicalWidth) {
            b.vx *= -1;
            b.x = b.x < BUBBLE_RADIUS ? BUBBLE_RADIUS : logicalWidth - BUBBLE_RADIUS;
            // Update step velocity after bounce
          }

          // Top Hit
          if (b.y - BUBBLE_RADIUS < 0) {
            this.snapToGrid(b);
            return; // Exit update after snapping
          }

          // Grid Collision
          if (this.checkGridCollision(b)) {
            return; // Exit update after snapping
          }
        }

        // Safety: If bubble somehow flies off bottom or sides without snapping

        if (b.y > logicalHeight + 50 || b.x < -50 || b.x > logicalWidth + 50) {
          this.spawnBubble();
        }
      }
    },
    checkGridCollision(b) {
      // Only check rows that are near the bubble to optimize
      const {
        row
      } = this.getGridPos(b.x, b.y);
      const startRow = Math.max(0, row - 2);
      const endRow = Math.min(GRID_ROWS - 1, row + 2);
      for (let r = startRow; r <= endRow; r++) {
        for (let c = 0; c < GRID_COLS; c++) {
          const color = this.gameState.grid[r][c];
          if (color) {
            const coords = this.getBubbleCoords(r, c);
            const distSq = (b.x - coords.x) ** 2 + (b.y - coords.y) ** 2;
            // Using squared distance for performance
            // 1.8 * BUBBLE_RADIUS is a good collision threshold
            if (distSq < (BUBBLE_RADIUS * 1.8) ** 2) {
              this.snapToGrid(b);
              return true;
            }
          }
        }
      }
      return false;
    },
    snapToGrid(b) {
      const {
        row,
        col
      } = this.getGridPos(b.x, b.y);
      const targetRow = Math.max(0, Math.min(GRID_ROWS - 1, row));
      const targetCol = Math.max(0, Math.min(GRID_COLS - 1, col));
      if (this.gameState.grid[targetRow][targetCol] === null) {
        this.gameState.grid[targetRow][targetCol] = b.color;
        this.popBubbles(targetRow, targetCol, b.color);
        if (targetRow >= GRID_ROWS - 2) {
          this.gameState.status = GameStatus.GAMEOVER;
          audioManager.play('fail');
        } else {
          this.checkInfiniteMode();
          this.spawnBubble();
        }
      } else {
        const neighbors = this.findNeighbors(targetRow, targetCol);
        let bestNeighbor = null;
        let minDist = Infinity;
        for (const n of neighbors) {
          if (this.gameState.grid[n.row][n.col] === null) {
            const coords = this.getBubbleCoords(n.row, n.col);
            const d = Math.sqrt((b.x - coords.x) ** 2 + (b.y - coords.y) ** 2);
            if (d < minDist) {
              minDist = d;
              bestNeighbor = n;
            }
          }
        }
        if (bestNeighbor) {
          this.gameState.grid[bestNeighbor.row][bestNeighbor.col] = b.color;
          this.popBubbles(bestNeighbor.row, bestNeighbor.col, b.color);
          if (bestNeighbor.row >= GRID_ROWS - 2) {
            this.gameState.status = GameStatus.GAMEOVER;
            audioManager.play('fail');
          } else {
            this.checkInfiniteMode();
            this.spawnBubble();
          }
        } else {
          this.gameState.status = GameStatus.GAMEOVER;
          audioManager.play('fail');
        }
      }
    },
    checkInfiniteMode() {
      if (this.gameState.shotsFired % SHOTS_BEFORE_NEW_ROW === 0) {
        this.addNewRow();
      }
    },
    draw() {
      const canvas = this.$refs.canvasRef;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const dpr = window.devicePixelRatio || 1;
      const logicalWidth = canvas.width / dpr;
      const logicalHeight = canvas.height / dpr;

      // Clear the entire physical canvas area
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      ctx.scale(dpr, dpr);

      // Draw Grid
      for (let r = 0; r < GRID_ROWS; r++) {
        for (let c = 0; c < GRID_COLS; c++) {
          const color = this.gameState.grid[r][c];
          if (color) {
            const {
              x,
              y
            } = this.getBubbleCoords(r, c);
            this.drawBubble(ctx, x, y, color);
          }
        }
      }

      // Draw Aim Line
      if (this.gameState.status === GameStatus.PLAYING && this.currentBubble && !this.currentBubble.active) {
        const b = this.currentBubble;
        ctx.beginPath();
        ctx.setLineDash([5, 5]);
        ctx.moveTo(b.x, b.y);
        ctx.lineTo(b.x + Math.cos(this.angleRef) * 150, b.y - Math.sin(this.angleRef) * 150);
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
        ctx.stroke();
        ctx.setLineDash([]);
      }
      // Draw Current Bubble
      if (this.currentBubble) {
        const b = this.currentBubble;
        this.drawBubble(ctx, b.x, b.y, b.color);
      }

      // Draw Next Bubble Preview
      ctx.fillStyle = 'rgba(255, 255, 255, 0.05)';
      ctx.beginPath();
      ctx.arc(logicalWidth - 40, logicalHeight - 40, BUBBLE_RADIUS + 5, 0, Math.PI * 2);
      ctx.fill();
      this.drawBubble(ctx, logicalWidth - 40, logicalHeight - 40, this.nextBubbleColor);

      // Draw Danger Line
      ctx.beginPath();
      ctx.moveTo(0, (GRID_ROWS - 2) * ROW_HEIGHT + BUBBLE_RADIUS * 2);
      ctx.lineTo(logicalWidth, (GRID_ROWS - 2) * ROW_HEIGHT + BUBBLE_RADIUS * 2);
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.5)';
      ctx.setLineDash([10, 10]);
      ctx.stroke();
      ctx.setLineDash([]);
      ctx.restore();
    },
    drawBubble(ctx, x, y, color) {
      ctx.shadowBlur = 8;
      ctx.shadowColor = 'rgba(0,0,0,0.4)';
      const gradient = ctx.createRadialGradient(x - 5, y - 5, 2, x, y, BUBBLE_RADIUS);
      gradient.addColorStop(0, 'white');
      gradient.addColorStop(0.3, color);
      gradient.addColorStop(1, color);
      ctx.beginPath();
      ctx.arc(x, y, BUBBLE_RADIUS, 0, Math.PI * 2);
      ctx.fillStyle = gradient;
      ctx.fill();
      ctx.shadowBlur = 0;
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
      ctx.lineWidth = 1;
      ctx.stroke();
      ctx.beginPath();
      ctx.ellipse(x - 6, y - 6, 6, 4, Math.PI / 4, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
      ctx.fill();
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "bubbleShooter"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
        this.countDown();
      });
    },
    async end() {
      if (this.lastScore >= this.gameState.score) return;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "bubbleShooter",
        level: 1,
        score: this.gameState.score,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "bubbleShooter"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.userReward = rs.data.userReward ?? null;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(() => {
        if (this.leftTime <= 0) {
          this.gameState.status = GameStatus.MENU;
          this.init();
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    handleRevive() {
      if (this.revives <= 0) return;
      const callback = res => {
        // Clear bottom 5 rows to give space
        const newGrid = [...this.gameState.grid];
        for (let r = GRID_ROWS - 1; r >= GRID_ROWS - 8; r--) {
          if (r >= 0) {
            newGrid[r] = new Array(GRID_COLS).fill(null);
          }
        }
        this.gameState.grid = newGrid;
        this.gameState.status = GameStatus.PLAYING;
        //this.gameState.score = 0;
        this.revives = this.revives - 1 >= 0 ? this.revives - 1 : 0;
        this.spawnBubble();
      };
      try {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } catch (e) {
        callback(null);
      }
    },
    handleCancel() {
      this.gameState.status = GameStatus.MENU;
    },
    // 复活逻辑：移除所有 2 和 4，腾出空间
    handleConfirm() {
      this.revives > 0 ? this.handleRevive() : this.handleCancel();
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.popGameRankShow = true;
      });
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "bubbleShooter"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    onMouseMove(e) {
      this.updateAngle(e.clientX, e.clientY);
    },
    onTouchMove(e) {
      if (e.touches && e.touches.length > 0) {
        const t = e.touches[0];
        this.updateAngle(t.clientX, t.clientY);
      }
    },
    onMouseDown(e) {
      this.shoot(e);
    },
    onTouchStart(e) {
      if (e.touches && e.touches.length > 0) {
        this.shoot(e);
      }
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.popStartShow = true;
  }
};